import {FormDrawer} from './FormDrawer';
import {DrawerProps} from '@mantine/core';
import {usePrice} from '../hooks/usePrice';
import {Price} from '../types';

export const AddFormDrawer = (props: DrawerProps) => {

    const {createRecord} = usePrice();

    return (
        <FormDrawer
            record={{
                id: '',
                currency: 'usd',
                product: '',
                unitAmount: '',
                active: true,
                nickname: '',
                billingScheme: 'perUnit',
            } as Price}
            handleSubmit={createRecord}
            {...props}
        />
    );
};
